import { render, staticRenderFns } from "./card-gap.vue?vue&type=template&id=5c90be24&"
import script from "./card-gap.vue?vue&type=script&lang=js&"
export * from "./card-gap.vue?vue&type=script&lang=js&"
import style0 from "./card-gap.vue?vue&type=style&index=0&id=5c90be24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports